import { h } from 'preact';
import util from 'preact-util';
import { Text } from 'preact-i18n';

/**
 * Small "Printed <date>" mark shown inside the "Skriv ut" buttons once a print
 * has stamped sale.printedDate (POST /api/sales/:id/printed via
 * saleStore.markPrinted; see backend/lib/sale-printed.js). Renders nothing
 * until then.
 */
const PrintedMark = ({ sale }) => {
    if (!sale || !sale.printedDate) {
        return null;
    }
    return (
        <small class='ms-2 opacity-75'>
            <i class='fa-solid fa-check' /> <Text id='dyrejournal.printed'>Printed</Text> {util.isoDate(sale.printedDate, false, false, true)}
        </small>
    );
};

export default PrintedMark;
